import { lazy, Suspense, useEffect } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { VoxnelaLoader } from './components/ui/VoxnelaMark'
import { VideoAppShell } from './video/components/VideoAppShell'
import { StudioWorkspaceProvider } from './studio/contexts/StudioWorkspaceContext'
import { useStudioWorkspace } from './studio/contexts/StudioWorkspaceContext'
import { useTranslation } from 'react-i18next'
import { useNativeInteractionFeedback } from './hooks/useNativeInteractionFeedback'

const InspirationHomePage = lazy(() =>
  import('./video/pages/InspirationHomePage').then((module) => ({
    default: module.InspirationHomePage,
  })),
)
const StudioExplorePage = lazy(() =>
  import('./studio/pages/StudioExplorePage').then((module) => ({
    default: module.StudioExplorePage,
  })),
)
const StudioGalleryPage = lazy(() =>
  import('./studio/pages/StudioGalleryPage').then((module) => ({
    default: module.StudioGalleryPage,
  })),
)
const InformationPage = lazy(() =>
  import('./pages/InformationPage').then((module) => ({
    default: module.InformationPage,
  })),
)

function OpenImageStudio() {
  const { openStudioWithPreset } = useStudioWorkspace()
  useEffect(() => { openStudioWithPreset('style_transfer') }, [openStudioWithPreset])
  return <Navigate to="/" replace />
}

export default function App() {
  const { t } = useTranslation()
  useNativeInteractionFeedback()
  return (
    <StudioWorkspaceProvider>
      <Suspense fallback={<VoxnelaLoader label={t('common.loading')} />}>
        <Routes>
          <Route path="/contact" element={<InformationPage kind="contact" />} />
          <Route path="/privacy" element={<InformationPage kind="privacy" />} />
          <Route path="/terms" element={<InformationPage kind="terms" />} />
          <Route element={<VideoAppShell />}>
            <Route index element={<InspirationHomePage />} />
            <Route path="/chat" element={<Navigate to="/" replace />} />
            <Route path="/explore" element={<StudioExplorePage />} />
            <Route path="/projects" element={<StudioGalleryPage />} />
            <Route path="/gallery" element={<StudioGalleryPage />} />
            <Route path="/new" element={<OpenImageStudio />} />
            <Route path="/project/:projectId" element={<Navigate to="/projects" replace />} />
            <Route path="/videos" element={<Navigate to="/projects" replace />} />
            <Route path="/membership" element={<Navigate to="/" replace />} />
            <Route path="/library" element={<Navigate to="/projects" replace />} />
            <Route path="/created" element={<Navigate to="/projects" replace />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      </Suspense>
    </StudioWorkspaceProvider>
  )
}
